export const EC2_SERVER_STATIC_IPV4 = 'app.lumas.live' 
// Note: Let's Encrypt SSL is valid for domain name, not IP address or localhost. Therefore, use domain name in production mode.

// Connect to the Production EC2 MQTT server 
export const MQTT_BROKER_URL = `wss://mqtt.lumas.live:1885`;

// design note: client does not directly access API server, but instead sends requests to the web server, which forwards them to the API server
// TODO - if in production, use the domain name EC2-hosted API. If in development mode, use localhost for the api.
export const API_URL = process.env.NODE_ENV === 'production'
    ? `https://${EC2_SERVER_STATIC_IPV4}/api`
    : `https://localhost:3000/api`;     // connect to the DEV web-app-server via HTTPS on port 3000

export const ADD_HEART_VERIFICATION_TOPIC = "LumasHearts/hearts/verify";

// send requests to the API server (protocol dynamically determined by the current URL host)
// export const API_URL = process.env.API_URL || `${window.location.protocol}//${window.location.host === "localhost:3000" ? "localhost:443" : window.location.host}/api`;

// backup option:
// export const API_URL = process.env.NODE_ENV === 'production'
//   ? 'https://heartapp-c3oe.onrender.com/api'
//   : 'http://localhost:10001/api';

export const BROKER_OPTIONS = {
    clientId: `client_${Math.random().toString(16).substr(2, 8)}`,  // generate a unique client ID
    reconnectPeriod: 1000, // Reconnect after 1 second if disconnected
    connectTimeout: 30 * 1000, // 30 seconds to attempt reconnection
    clean: true, // Remove session state after disconnect (clean session on each new connection)

};

export const MQTT_TOPIC_PREFIX = "LumasHearts/groups/";

export const DEFAULT_HEART_COLOR_NUMBER = 0; // red

export const EMPTY_GROUP_ID = "None";

export const LOCATION_UPDATER_TOPIC = "startLocationUpdater"

export const MAX_GROUP_SIZE = 20;
